/// Menu
import MetisMenu from "metismenujs";
import React, { Component } from "react";
import { connect } from 'react-redux';
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";

import { currentUser } from '../../../store/selectors/CurrentUserSelector';
import { withTranslation } from 'react-i18next';


class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {
  /// Open menu
  componentDidMount() {
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    // Start collapsed by default (set menu-toggle class on load)
    const isMenuOpen = localStorage.getItem('menuOpen') === 'true';
    if (!isMenuOpen) {
      aaa.classList.add("menu-toggle");
    }

    function toggleFunc() {
      const isOpen = aaa.classList.toggle("menu-toggle");
      // Save state to localStorage
      localStorage.setItem('menuOpen', !isOpen);
    }
    btn.addEventListener("click", toggleFunc);
  }
  state = {
    loveEmoji: false
  };

  hasAccess(menuName) {
      return this.props.currentUser.menus?.filter(menu => menu.code === menuName).length > 0;
  }
  
  canDo(menuCode, actionCode){
    let theMenu = this.props.currentUser.menus?.find(menu => menu.code === menuCode);
    if(!theMenu){
      return false;
    }else{
      return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
    }
  }

  hasMenu(menuCode) {
      return this.props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
  }

  render() {
    /// Path
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    /// Active menu
    let dashBoard = [
      "dashboard",
      
    ]

    let authentification = [
      "patient-list",
      "provider-view"
    ];
    
    /// Active menu
    let clients = [
      "client-list",
      "client-group-register",
      "assure-search"
  ];
  /// Active menu
  let providers = [
    "provider-list",
    "provider-form",
  ];

  /// Active menu
  let accordsPrea = [
    "accords-list",
    "proformas"
  ];

  let settings = [
    "Parametrage",
    "user-profil",
    "provider-setting",
    "parametre-generaux"
  ]

  /// Active menu
  let consultations = [
    "consultation-list",
  ];

  /// Active menu
  let facturation = [
    "facturation"
  ];

  /// Active menu
  let remboursement = [
    "remboursement-form",
    "demande-remboursement",
    "remboursement-list"
  ];

  /// Active menu
  let rapport = [
    "rapportform",
    "consommation-list",
    "etats-prestataires"
  ];

  /// Active menu
  let prestations = [
    "prestations"
  ];

  let monitoring = [
    "monitoring",
    "historiques-avenants",
    "codes-validation",
    "historique-identifications",
    "Synchronisation"
  ];

  let avenants = [
    "demandes-avenant"
  ]

  let sinistres = [
    "sinistres",
    "sinistres-declares",
    "recours",
    "evaluations",
    "reglements",
  ]

  let gestionCartes = [
    "cartes-gestion-complete"
  ]

  let restrictions = [
    "restrictions-dashboard",
    "restrictions-list",
    "restrictions-create"
  ]

  let enrollments = [
    "enrollment-identification",
    "enrollment-batch",
    "enrollment-list"
  ]


    return (
      <div className="deznav">
        <PerfectScrollbar className="deznav-scroll">
          <MM className="metismenu" id="menu">
            {(this.hasMenu('MENIDENT') || this.hasMenu('MENENROLL')) && <li className={`${dashBoard.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-chart-bar"></i>
                <span className="nav-text">Dashboard</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "" ? "mm-active" : ""}`} to="" onClick={() => {
                      this.props.onClick3();
                      this.props.closeMenu();
                    }}>
                    <i className="la la-chalkboard"></i>
                    <span>Dashboard</span>
                  </Link>
                </li>
              </ul>
            </li>}            
            {(this.hasMenu('MENIDENT') || this.hasMenu('MENENROLL')) && <li className={`${authentification.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-user-cog"></i>
                <span className="nav-text">{this.props.t('layout.authentication')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/identification">
                    <i className="la la-address-card"></i>
                    <span style={{fontSize:12, alignContent:'center', flexWrap:'wrap',alignSelf:'center'}} >{this.props.t('layout.patient-identification')}</span>
                  </Link>
                </li>
                {this.hasAccess('ProfilPrestataire') && <li>
                  <Link className={`${path === "patient-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/client-search">
                    <i className="la la-user-injured"></i>
                    <span>{this.props.t('layout.patient-enrollment')}</span>
                  </Link>
                </li>}
                {this.hasAccess('ProfilPrestataire') && <li>
                  <Link className={`${path === "assure-search" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/assure-search">
                  <i className="las la-user-check"></i>
                    <span>Assurés enrôlés</span>
                  </Link>
                </li>}
              </ul>
            </li>}

            {this.hasMenu('MENCARTES') && <li className={`${gestionCartes.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-id-card"></i>
                <span className="nav-text">{this.props.t('layout.card-management')}</span>
              </Link>
              <ul>

                <li>
                  <Link className={`${path === "cartes-gestion-complete" ? "mm-active" : ""}`}
                        onClick={() => this.props.onClick()}
                        to={"/cartes/gestion-complete"}>
                    <i className="la la-cogs"></i>
                    <span>Complete Management</span>
                  </Link>
                </li>
              </ul>
            </li>}

            {this.hasMenu('MENPROVIDER') && <li className={`${providers.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-hospital"></i>
                <span className="nav-text" >{this.props.t('dashboard.providers')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "" ? "mm-active" : ""}`} to="/provider-list" onClick={() => this.props.onClick3()}>
                    <i className="la la-stream"></i>
                    <span>{this.props.t('layout.list')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "provider-form" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/provider-form">
                    
                    <i className="la la-hospital-alt"></i>
                    <span>{this.props.t('layout.new-provider')}</span>
                    
                  </Link>
                </li>
              </ul>
            </li>}
            {(this.hasMenu('MENPARAM') || this.hasMenu('MENPARAMUSER') || this.hasMenu('MENPARAMACTES') ) && 
              <li className={`${settings.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#" >
                  <i className="la la-tools"></i>
                  <span className="nav-text">{this.props.t('layout.parameter')}</span>
                </Link>
                <ul>
                  {this.hasMenu('MENPARAM') && <li>
                    <Link className={`${path === "parametre-standarts" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/parametre-standarts">
                      
                    <i className="las la-wrench"></i>
                      <span>{this.props.t('layout.standart-params')}</span>
                      
                    </Link>
                  </li>}
                  {this.hasMenu('MENPARAM') && <li>
                    <Link className={`${path === "parametrage" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/parametrage">
                      
                      <i className="la la-tools"></i>
                      <span>{this.props.t('layout.general-params')}</span>
                      
                    </Link>
                  </li>}
                  {this.hasMenu('MENPARAM') && <li>
                    <Link className={`${path === "user-profil" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/user-profil">
                      <i className="la la-users"></i>
                      <span> {this.props.t('layout.user-roles')}</span>
                     
                    </Link>
                  </li>}
                  {this.hasMenu('MENPARAM') && <li>
                    <Link className={`${path === "provider-setting" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/provider-setting">
                      
                      <i className="la la-cogs"></i>
                      <span>{this.props.t('layout.act-prices')}</span>
                      
                    </Link>
                  </li>}
                </ul>
              </li>
            }

            {/* Menu Gestion des Restrictions */}
            {(this.hasMenu('MENPARAM') && this.hasMenu('MENACCESS')) && <li className={`${restrictions.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-ban"></i>
                <span className="nav-text">Gestion Restrictions</span>
              </Link>
              <ul>
                {this.hasMenu('MENPARAM') && <li>
                  <Link className={`${path === "restrictions-dashboard" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/restrictions/dashboard">
                    <i className="la la-chart-bar"></i>
                    <span>Dashboard</span>
                  </Link>
                </li>}
                {this.hasMenu('MENPARAM') && <li>
                  <Link className={`${path === "restrictions-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/restrictions/list">
                    <i className="la la-list"></i>
                    <span>Liste des Restrictions</span>
                  </Link>
                </li>}
                {this.hasMenu('MENPARAM') && <li>
                  <Link className={`${path === "restrictions-create" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/restrictions/create">
                    <i className="la la-plus"></i>
                    <span>Nouvelle Restriction</span>
                  </Link>
                </li>}
                {this.hasMenu('MENPARAM') && <li>
                  <Link className={`${path === "restrictions-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/restrictions/list">
                    <i className="la la-shield-alt"></i>
                    <span>Règles d'Accès</span>
                  </Link>
                </li>}
                {this.hasMenu('MENPARAM') && <li>
                  <Link className={`${path === "restrictions-dashboard" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/restrictions/dashboard">
                    <i className="la la-chart-bar"></i>
                    <span>Tableau de Bord</span>
                  </Link>
                </li>}
              </ul>
            </li>}

            {/* Menu Gestion des Enrollments */}
            {(this.hasMenu('MENPARAM') && this.hasMenu('MENACCESS')) && <li className={`${enrollments.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-user-plus"></i>
                <span className="nav-text">Gestion Enrollments</span>
              </Link>
              <ul>
                <li>
                  <Link className={`${path === "enrollment-identification" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/enrollment/identification">
                    <i className="la la-fingerprint"></i>
                    <span>Identification Patient</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "enrollment-batch" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/enrollment/batch">
                    <i className="la la-list"></i>
                    <span>Enrollments</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "enrollment-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/enrollment/list">
                    <i className="la la-users"></i>
                    <span>Liste des Assurés</span>
                  </Link>
                </li>
              </ul>
            </li>}

            {(this.hasMenu('MENACCORD') || this.hasMenu('MENPROFORMA')) && <li className={`${accordsPrea.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow ai-icon" to="#" >
                  <i className="la la-hand-paper"></i>
                  <span className="nav-text">{this.props.t('layout.agreement')}</span>
                </Link>
                <ul>
                {this.hasMenu('MENACCORD') && <li>
                    <Link className={`${path === "accords-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/accords-list">
                      <i className="la la-praying-hands"></i>
                      <span>{this.props.t('layout.other-acts')}</span>  
                      
                    </Link>
                  </li>}
                  {this.hasMenu('MENPROFORMA') && <li>
                    <Link className={`${path === "proformas" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/proformas">
                      <i className="la la-glasses"></i>
                      <span>{this.props.t('layout.optics')}</span>  
                      
                    </Link>
                  </li>}
                  {this.hasMenu('MENPROFORMA') && <li>
                    <Link className={`${path === "proformas-kine" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to="/proformas-kine">
                      <i className="la la-wheelchair"></i>
                      <span>{this.props.t('layout.kines')}</span>  
                      
                    </Link>
                  </li>}
                </ul>
              </li>
            }
            {this.hasMenu('MENCONSULTADMIN') && <li className={`${consultations.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-stethoscope"></i>
                <span className="nav-text" >{this.props.t('dashboard.consults')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "consultation-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/consultation-list"}>
                    <i className="la la-notes-medical"></i>
                    <span>{this.props.t('layout.consult-folders')}</span>
                  </Link>

                </li>
              </ul>
            </li>}
            {this.hasMenu('MENFACTUREADMIN') && <li className={`${facturation.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-file-invoice-dollar"></i>
                <span className="nav-text">{this.props.t('layout.bills')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "facturation" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/facturation"}>
                  <i className="las la-history"></i>
                    <span>{this.props.t('layout.history')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "facturation" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/factures-prestataires"}>
                  <i className="las la-file-invoice"></i>
                    <span>{this.props.t('layout.provider-bills')}</span>
                  </Link>
                </li>
              </ul>
            </li>}
            {this.hasMenu('MENREMBOURS') && <li className={`${remboursement.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="las la-hand-holding-usd"></i>
                <span className="nav-text">{this.props.t('layout.payback')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "demande-remboursement" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/demande-remboursement"}>
                  <i className="las la-spinner"></i>
                    <span>{this.props.t('layout.request')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "remboursement-list" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/remboursement-list"}>
                    <i className="la la-file-invoice"></i>
                    <span>{this.props.t('layout.list')}</span>
                  </Link>
                </li>
              </ul>
            </li>}
            {this.hasMenu('MENPRESTATION') && <li className={`${prestations.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
              <i className="las la-user-shield"></i>
                <span className="nav-text" >{this.props.t('dashboard.prestations')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "prestations" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/prestations"}>
                  <i className="las la-history"></i>
                    <span>{this.props.t('layout.history')}</span>
                  </Link>
                </li>
              </ul>
            </li>}
            {this.hasMenu('MENREPORTING') && <li className={`${rapport.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-file-invoice-dollar"></i>
                <span className="nav-text">{this.props.t('dashboard.souscipt')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "etats-prestataires" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/etats-prestataires"}>
                    <i className="la la-file-invoice"></i>
                    <span>{this.props.t('layout.state')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "rapport-global" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/rapport-global"}>
                  <i className="las la-folder-open"></i>
                    <span>{this.props.t('layout.global-state')}</span>
                  </Link>
                </li>
              </ul>
            </li>}
            {this.hasMenu('MENMONITORING') && <li className={`${monitoring.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-desktop"></i>
                <span className="nav-text">{this.props.t('layout.monitor')}</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "monitoring" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/monitoring"}>
                    <i className="la la-desktop"></i>
                    <span>{this.props.t('layout.monitor')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "codes-validation" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/codes-validation"}>
                  <i className="las la-clipboard-check"></i>
                    <span>{this.props.t('layout.validation-code')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "historique-identifications" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/historique-identifications"}>
                  <i className="las la-history"></i>
                    <span>{this.props.t('layout.auth-history')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "synchronisation" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/synchronisation"}>
                  <i className="las la-sync"></i>
                    <span>{this.props.t('synchronisation')}</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "providers" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/monitoring/providers"}>
                  <i className="las la-home"></i>
                    <span>{this.props.t('providers')}</span>
                  </Link>
                </li>
              </ul>
            </li>}
            {this.hasMenu('MENAVENADMIN') && <li className={`${avenants.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
              <i className="las la-id-card-alt"></i>
                <span className="nav-text">Demandes d'avenant</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "demandes-avenant" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/demandes-avenant"}>
                  <i className="las la-history"></i>
                    <span>Historique</span>
                  </Link>
                </li>
              </ul>
            </li>}
            {this.hasMenu('MENAVENADMIN') && <li className={`${sinistres.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow ai-icon" to="#" >
                <i className="la la-exclamation-circle"></i>
                <span className="nav-text">Sinistres</span>
              </Link>
              <ul >
                <li>
                  <Link className={`${path === "sinistres" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/sinistres"}>
                    <i className="la la-exclamation-circle"></i>
                    <span>Sinistres</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "sinistres-declares" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/sinistres-declares"}>
                    <i className="la la-exclamation"></i>
                    <span>Sinistres Déclarés</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "recours" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/recours"}>
                    <i className="la la-headset"></i>
                    <span>Recours</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "evaluations" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/evaluations"}>
                    <i className="la la-vial"></i>
                    <span>Evaluations</span>
                  </Link>
                </li>
                <li>
                  <Link className={`${path === "reglements" ? "mm-active" : ""}`} onClick={() => this.props.onClick()} to={"/reglements"}>
                    <i className="la la-comment-dollar"></i>
                    <span>Règlements</span>
                  </Link>
                </li>
              </ul>
            </li>}

          </MM>
        </PerfectScrollbar>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
      currentUser: currentUser(state),
      authData: state.auth.auth,
  };
};

export default withTranslation()(connect(mapStateToProps)(SideBar));
